import { render, staticRenderFns } from "./SosReasonPopup.vue?vue&type=template&id=d5a124f2&"
import script from "./SosReasonPopup.vue?vue&type=script&lang=js&"
export * from "./SosReasonPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports